import { VALUES_PER_PAGE } from 'components/pagination/constants';
import { ORDER_BY } from 'components/table/constants';
import { action } from 'mobx';
import { CommunityService, CommunityStore } from 'modules/community';
import { TABS_INDEXES } from 'modules/community/constants';
import CommunityHistoryService from 'modules/community/history/CommunityHistoryService';
import { UiService } from 'modules/ui';

class CommentListService {
  initializeDataTableParams = () => {
    const dataTableParams = {
      pagination: {}
    };

    dataTableParams.pagination.page = 0;
    dataTableParams.pagination.perPage = VALUES_PER_PAGE.TEN;
    dataTableParams.perPage = 10;
    dataTableParams.sortOptions = { comment: ORDER_BY.ASC };

    return dataTableParams;
  };

  getCommentsDataToSend = ({ items, status, userId = null }) =>
    (items || []).map((item) => ({
      commentId: item.id,
      commentUserId: item.user.id,
      userId,
      ...(status && { status })
    }));

  getCommentsUpdateData(selectedAll, commentsChecked, status) {
    const { comments } = CommunityStore;

    const items = selectedAll ? comments : commentsChecked;

    return this.getCommentsDataToSend({ items, status });
  }

  async commentStatusUpdate(item, status) {
    const commentId = item && item.id;
    const commentUserId = item && item.user && item.user.id;

    const response = await CommunityService.commentStatusUpdate(
      status,
      commentUserId,
      commentId
    );

    if (response) {
      UiService.setAlertSuccess(CommunityHistoryService.statusMessage[status]);
    }
  }

  getClassLabel = (classesList, classId) => {
    const classData = classesList.find(
      (classData) => classData.value === classId
    );

    return classData ? classData.label : '';
  };

  @action
  updateSelectedComments(comments, selectAll) {
    const newComments = comments.map((item) => ({
      ...item,
      _checked: selectAll
    }));

    CommunityStore.setComments(newComments);
  }

  getFirstName(item) {
    const firstNameIndex = 0;

    return item && item.user && item.user.name.split(' ')[firstNameIndex];
  }

  isAllTab(activedTab) {
    return activedTab === TABS_INDEXES.all;
  }
}

export default new CommentListService();
